export default __webpack_public_path__ + "static/media/sports13.5258d694.jpg";